import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';

@Component({
  selector: 'app-read-text',
  template: `
  <div [formGroup]="group" *ngIf="field.style.visibility">
  <div class="hazard-description">
    <p>{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
  </div>
</div>
  `,
  styles: []
})

export class ReadTextComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor() {}
  onChange(event) {
    this.field.value = event.value;
    this.group.value[this.field.id] = this.field.value; 
  }
  mouseEnter(event) {
    this.field.value = event.value;
    this.group.value[this.field.id] = this.field.value;
  }
  mouseLeave(event) {
    this.field.value = event.value;
    this.group.value[this.field.id] = this.field.value;
  }
  ngOnInit() {}

}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/read-text/read-text.component.ts